<template>
  <span class="textarea-plus">
    <textarea
      ref="textarea"
      :value="modelValue"
      @input="handleKeyStroke"
      class="form-control"
      :placeholder="placeholder"
    ></textarea>
  </span>
</template>

<script>
/**
 * @todo Replace Textarea-Plus with this verison (Textarea-Plus-Two)
 *
 * Added v-model support
 * by using prop "value" as :value
 * and emit "input" on @input.
 * More info: https://alligator.io/vuejs/add-v-model-support/
 */
export default {
  name: 'textarea-plus-two',
  props: {
    modelValue: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '...'
    }
  },
  mounted() {
    this.textareaAdjust(this.$refs.textarea)
  },
  methods: {
    handleKeyStroke: function handleKeyStroke (event) {
      this.textareaAdjust(event.target)
      this.updateValue()
    },
    textareaAdjust: function textAreaAdjust (element) {
      var el = element
      el.style.height = '1px'
      el.style.height = (25 + el.scrollHeight) + 'px'
    },
    updateValue () {
      this.$emit('update:modelValue', this.$refs.textarea.value)
    }
  }
}
</script>

<style scoped>
    textarea {
        resize: vertical;
        overflow: hidden;
    }
</style>
